import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ValBrowserStorageService } from './val-browser-storage.service';

@Injectable()
export class ValAuthGuard implements CanActivate {
  constructor(private _st: ValBrowserStorageService, private _r: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._st.getToken()) {
      return true;
    } else {
      this._r.navigateByUrl('/login');
      return false;
    }
  }

}
